import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import NotListedLocationIcon from "@mui/icons-material/NotListedLocation";
import LS_LocationsIcon from '../_images/locicons/LS_LocationsIcon.png';
import LS_PartnerIcon from '../_images/partnericons/LS_PartnerIcon.png';
import LS_SameDayIcon from '../_images/samedayicons/LS_SameDayIcon.png';
import Guard_LocationsIcon from '../_images/locicons/Guard_LocationsIcon.png';
import Guard_PartnerIcon from '../_images/partnericons/Guard_PartnerIcon.png';
import Guard_SameDayIcon from '../_images/samedayicons/Guard_SameDayIcon.png';
import Mon_LocationsIcon from '../_images/locicons/Mon_LocationsIcon.png';
import Mon_PartnerIcon from '../_images/partnericons/Mon_PartnerIcon.png';
import Mon_SameDayIcon from '../_images/samedayicons/Mon_SameDayIcon.png';
import QS_LocationsIcon from '../_images/locicons/QS_LocationsIcon.png';
import QS_PartnerIcon from '../_images/partnericons/QS_PartnerIcon.png';
import QS_SameDayIcon from '../_images/samedayicons/QS_SameDayIcon.png';

import {
  LifeSafer,
  Monitech,
  Guardian,
  QuickStart,
} from "../_helpers/BrandConstants";

export const GoogleMapsLegend = () => {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  //default to LS
  let locationsIconUrl = LS_LocationsIcon;
  let partnerIconUrl = LS_PartnerIcon;
  let sameDayIconUrl = LS_SameDayIcon;
  if (brand === LifeSafer) {
    locationsIconUrl = LS_LocationsIcon;
    partnerIconUrl = LS_PartnerIcon;
    sameDayIconUrl = LS_SameDayIcon;
  } else if (brand === Guardian) {
    locationsIconUrl = Guard_LocationsIcon;
    partnerIconUrl = Guard_PartnerIcon;
    sameDayIconUrl = Guard_SameDayIcon;
  } else if (brand === Monitech) {
    locationsIconUrl = Mon_LocationsIcon;
    partnerIconUrl = Mon_PartnerIcon;
    sameDayIconUrl = Mon_SameDayIcon;
  } else if (brand === QuickStart) {
    locationsIconUrl = QS_LocationsIcon;
    partnerIconUrl = QS_PartnerIcon;
    sameDayIconUrl = QS_SameDayIcon;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls={open ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        style={{
          marginLeft: 268,
          marginTop: -316,
          backgroundColor: "#fff",
          borderRadius: 2,
        }}
      >
        <NotListedLocationIcon fontSize="large" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ height: 36, cursor: "default" }}
        >
          <Grid>
            <Typography style={{ fontWeight: "bold" }}>
              {t("outro.mapInfo")}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <MenuItem disabled className="disabledOverride">
          <img style={{ width: 36, height: 36 }} src={partnerIconUrl} alt="" />
          {t("outro.partnerLoc")}
        </MenuItem>
        <MenuItem disabled className="disabledOverride">
          <img style={{ width: 36, height: 36 }} src={sameDayIconUrl} alt="" />
          {t("outro.sameDayLoc")}
        </MenuItem>
        <MenuItem disabled className="disabledOverride">
          <img
            style={{ width: 36, height: 36 }}
            src={locationsIconUrl}
            alt=""
          />
          {t("outro.standardLoc")}
        </MenuItem>
      </Menu>
    </>
  );
};
